let quantityBreakRender = true;
const observer = new MutationObserver((mutations, obs) => {
    let quantityBreak = document.querySelector(".quantity-breaks-now-wrapper");
    if (quantityBreak) {
        console.log("apped quantity-breaks-now-wrapper");
        quantityBreak.style.maxHeight = null;
        let toggler = document.querySelector(".toggleVolumnDiscount");
        quantityBreak.parentNode.insertBefore(toggler,quantityBreak);
        if(quantityBreakRender == false)
        {
          toggler.classList.add("active");
          document.querySelector(".offer-loading").style.display = "none";
          quantityBreak.style.maxHeight = quantityBreak.scrollHeight + "px";
          quantityBreakRender = true;
        }
        obs.disconnect(); // Stop observing once found
    }
    
});

observer.observe(document.body, { childList: true, subtree: true });

document.querySelector(".toggleVolumnDiscount").addEventListener("click", function() {
  if(document.querySelector(".quantity-breaks-now-wrapper") != null)
  {
    this.classList.toggle("active");
    if (document.querySelector(".quantity-breaks-now-wrapper").style.maxHeight) {
      document.querySelector(".quantity-breaks-now-wrapper").style.maxHeight = null;
    } else {
      document.querySelector(".quantity-breaks-now-wrapper").style.maxHeight = document.querySelector(".quantity-breaks-now-wrapper").scrollHeight + "px";
    }
  }
  else
  {
    this.classList.toggle("active");
    quantityBreakRender = false;
    document.querySelector(".offer-loading").style.display = "block";
  }
  
});

